export type CashUnits = number[];

/**
 * @ngdoc service
 * @name posApp.cashUnits
 * @description
 * Constant containing array available coins & banknotes units.
 */
angular
  .module('posApp')
  .factory('cashUnits', [
    () => [0.01, 0.02, 0.05, 0.1, 0.2, 0.5, 1, 2, 5, 10, 20, 50, 100, 200, 500],
  ]);
